import styled from 'styled-components';
import Stack from 'src/app/atoms/Layout/Stack/Stack';

interface FillSpaceContainerProps {
  $height?: string | number;
}

const formatHeight = (height: string | number): string => {
  if (typeof height === 'number') return `${height}px`;
  return height;
};

export const FillSpaceContainer = styled(Stack)<FillSpaceContainerProps>`
  ${({ $height }) => $height !== undefined && `height: ${formatHeight($height)};`}
`;
